import * as yup from 'yup'

const schema = yup.object().shape({
  document: yup.string().required(),
})

export default schema
